export class EmployeeWorkingHrsRequest {

    departmentId: number;
    logDateStartDate?: any;
    logDateEndDate?: any;
    employeeCode?: any
    category?: string
    empType?: string



    /**
     * @param departmentId 
     */
    constructor(departmentId?: number, logDateStartDate?: any,
        logDateEndDate?: any, employeeCode?: any, category?: string, empType?: string
    ) {
        this.departmentId = departmentId;
        this.logDateEndDate = logDateEndDate
        this.logDateStartDate = logDateStartDate
        this.employeeCode = employeeCode
        this.category = category
        this.empType = empType

    }
}






export class PayrollRequestEmp {
    empType: string
    category: string
    departmentId?: number
   
    constructor(empType: string, category: string, departmentId?: number
    ) {
        this.empType = empType
        this.category = category
        this.departmentId = departmentId
    }
}








